import type { ColDefField, ServerColDef } from '@cmg/data-grid';
import { formatters } from '@cmg/data-grid';

import { RelationshipType } from '../../../../../../graphql';
import { RelationshipTypeCellEditor } from './RelationshipTypeCellEditor';

type CreateRelationshipTypeColDefProps<TData> = {
  field?: ColDefField<TData, RelationshipType>;
  editable: ServerColDef['editable'];
};

export function createRelationshipTypeColDef<TData extends { relationshipType: RelationshipType }>({
  field = 'relationshipType' as ColDefField<TData, RelationshipType>,
  editable,
}: CreateRelationshipTypeColDefProps<TData>): ServerColDef<TData, RelationshipType> {
  return {
    field,
    headerName: 'Relationship Type',
    editable,
    filter: 'agSetColumnFilter',
    cellEditor: RelationshipTypeCellEditor,
    valueFormatter: formatters.enumValueFormatter,
    filterParams: {
      values: Object.values(RelationshipType),
      valueFormatter: formatters.enumValueFormatter,
    },
  };
}
